import { render, staticRenderFns } from "./logoConfiguration.vue?vue&type=template&id=27d63a59&scoped=true&"
import script from "./logoConfiguration.vue?vue&type=script&lang=js&"
export * from "./logoConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./logoConfiguration.vue?vue&type=style&index=0&lang=css&"
import style1 from "./logoConfiguration.vue?vue&type=style&index=1&id=27d63a59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d63a59",
  null
  
)

export default component.exports